import maxBy from 'lodash/maxBy'
import { FileCategories } from '@/constants/backend/FileCategories'
import Image from '@/models-ts/Image'
import { replaceUploadUrl } from '@/utils/file'
import { parseJson } from '@/utils/parser'

export default class Avatar extends Image {
  static fromServer(data?: LX.Avatar | LX.Avatar[]): Avatar {
    if (Array.isArray(data) && data.length) {
      const images = data
        .filter((file) => file.category === FileCategories.CAT_IMG_RESIZED)
        .map((file) => {
          const width = parseJson(file.meta).width
          return width ? { src: file.url, width } : null
        })
        .filter(Boolean)
      const maxImage = maxBy(images, 'width')
      const srcSet = (images as Array<{ src: string; width: number }>)
        .map((file) => `${replaceUploadUrl(file.src)} ${file.width}w`)
        .join(', ')
      return new Avatar({
        src: replaceUploadUrl(maxImage?.src || data.find((file) => file.category === FileCategories.CAT_IMG_ORIGINAL)?.url),
        srcSet: srcSet || undefined,
      })
    }
    return new Avatar()
  }

  getMaxAvatar(userId: number) {
    return this.src || `${process.env.VUE_APP_FRONTEND_URL}/static/images/avatars/user-${(userId || 0) % 6}-360.png`
  }
}
